module.exports = __webpack_public_path__ + "static/seguranca-tooltip-4c85287d73ff9303e98d5f5552291bef.svg";